import axios from 'axios'
import * as _ from 'lodash'
import { app } from '../app'
import Vue from 'vue'
import Alert from '@bit/streamline.web.alert'

import store from '../store/index'

const axiosInstance = axios.create({
  baseURL: process.env.API_URL
})

const AlertComponent = Vue.extend(Alert)
const newAlert = propsData => new AlertComponent({ el: document.createElement('div'), propsData })

axiosInstance.interceptors.request.use((config) => {
  switch (config.method) {
    case 'delete':
      return store.dispatch('makeDeleteMessage', config).then((config) => {
        return Promise.resolve(config)
      }).catch(error => {
        app.$nprogress.done()
        throw new axios.Cancel(error)
      })
  }

  return config
})

axiosInstance.interceptors.response.use((response) => {
  switch (response.status) {
    case 204:
      response.data = []
      break
    case 200:
      response.data = filterObject(response.data)
      break
    default:
      console.log(response)
      break
  }

  return response
}, (error) => {
  if (error?.response) {
    error.name = `${error.config.method.charAt(0).toUpperCase() + error.config.method.slice(1)}${error.response.status || '???'}RequestError`
    error.message = error.response.data.message
    switch (error.response.status) {
      case 428: {
        console.warn('Status 428:', error.response.data)
        let resource = error.request.responseURL.split('/')
        resource = resource[resource.length - 2]
        const problems = error.response.data.meta.problems?.join(', ')
        newAlert({
          title: 'Kan niet verwijderen',
          message: `${resource} bevat ${problems}, verwijder of verplaats deze eerst`,
          type: 'warning',
          duration: 12000
        })
        error.response.data = filterObject(error.response.data)

        return Promise.reject(error)
      }
      case 403:
        console.warn('Status 403: Rejected')
        return Promise.reject(error)
      case 404:
        console.warn('Status 404: Not Found')
        newAlert({
          title: 'Geen resultaten gevonden',
          type: 'info'
        })
        return Promise.reject(error)
      case 401:
        console.warn('Status 401: Rejected')
        return Promise.reject(error)
      default:
        console.warn(`Status ${error.response.status}: Probably a server error`)
        newAlert({
          title: 'Server error',
          message: 'Als dit vaker gebeurt, noteer actie en tijdstip',
          type: 'error'
        })
        return Promise.reject(error)
    }
  }
  else if (error.message === 'Network Error') {
    newAlert({
      title: 'Verbinding met de database mislukt',
      message: 'Let op: aanpassingen kunnen nu niet worden opgeslagen',
      type: 'error',
      duration: 8000
    })
  }
  else {
    return Promise.reject(error)
  }
})

function filterObject (object) {
  if (!isNaN(object) || _.isString(object)) {
    return object
  }
  else if (object.data) {
    object = object.data
    object = filterObject(object)
    return object
  }
  else if (object.constructor === Object || object.constructor === Array) {
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        object[key] = filterObject(object[key])
      }
    }
    return object
  }

  return object
}

export default {
  axios: axiosInstance
}
